import styled from 'styled-components';
import {Form} from 'formik';
import {dFlex, alignCenter, dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const form = styled(Form)`
    ${dFlexColumn};
    gap: var(--space-xl);
    overflow: auto;
    max-height: calc(100% - 160px);
    padding: var(--space-xl) var(--space-lg);
`;

export const detailsRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--space-xl);
`;

export const footerWrap = styled.div`
    padding-bottom: var(--space-xl);
`;

export const summaryField = styled.div`
    ${dFlex};
    flex-direction: column;
    gap: var(--space-sm);
    & > div > div {
        border-color: var(--color-border-default);
        border-radius: 12px;
    }
`;

export const summaryHeader = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-xs);
`;

export const summaryLabel = styled.span`
    font-size: var(--font-size-body-small);
    color: var(--TA-color-text-subtle);
`;

export const charCounter = styled.span`
    font-size: var(--font-size-caption);
    color: var(--TA-color-text-subtle);
    margin-inline-start: auto;
    & b { font-weight: var(--font-weight-bold); }
`;
